import axios from 'axios';

// eslint-disable-next-line import/no-cycle
import { isNull, isEmpty } from 'lodash';
import { isObject } from 'lodash';

import { t } from '~/helpers';
import { store } from '~/store';
import { signOut } from '~/store/modules/auth/actions';

const api = axios.create({
  baseURL: sessionStorage.getItem('URL_BACKEND')
    ? sessionStorage.getItem('URL_BACKEND')
    : process.env.REACT_APP_URL_REQUEST,
});

api.interceptors.request.use(
  (config) => {
    // Obtenha a rota atual do sessionStorage (ou outro método compartilhado)
    const currentRoute = sessionStorage.getItem('CURRENT_ROUTE');

    if (currentRoute) {
      config.headers['Current-Route'] = currentRoute; // Adicione a rota ao cabeçalho
      // console.log(config);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isObject(error)) {
      const { status, data } = error.response;

      if (status === 403 || status === 401) {
        store.dispatch(signOut());

        const erros = ['você não tem permissão de acesso nesse servidor'];

        return Promise.reject(erros);
      }

      if (data && data.erros) {
        const { erros } = data;

        const arrayError = [t('s.geral.errogeralsistema')];
        const errorsNull = erros.filter((err) => isNull(err));

        if (!isEmpty(errorsNull)) return Promise.reject(arrayError);

        return Promise.reject(erros);
      }
    }
    if (error.message === 'Network Error') {
      return Promise.reject([t('s.geral.semconexaocomservidor')]);
    }

    const erros = [error.message];

    return Promise.reject(erros);
  }
);

export default api;
